<template>
    <div class="video-block" :class="props.size">
        <div class="container">
            <div class="row">
                <div :class="gridClass">
                    <div class="video-block__container">
                        <VideoComponent :autoplay="autoplay" :video-id="props.videoId" @on-play="handleOnPlay" @on-player-loaded="handlePlayerLoaded" @on-ended="handleOnEnded" />
                        <div v-if="!state.playing" class="video-block__cover" :style="{backgroundImage: `url(${props.image})`}">
                            <div v-if="showCustomControls" class="video-controls">
                                <button class="video-controls__play" @click="onClick">SPILL AV</button>
                                <p v-if="props.platform != VideoPlatform.youtube" class="video-controls__duration">{{ durationFormated }}</p>
                            </div>
                        </div>
                        <div v-if="props.size === VideoBlockSize.fullbleed" @click="onClick" class="video-block__overlay"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { defineAsyncComponent, reactive, computed } from 'vue';
    const VideoComponent = defineAsyncComponent(() => {
        if( props.platform === VideoPlatform.youtube ) {
            return import('./VideoBlockYoutube.vue');
        } return import('./VideoBlockVimeo.vue');
    });
    let player = null;
    const autoplay = props.size == VideoBlockSize.fullbleed;
    const state = reactive({ duration: 0, playing: false });
    const props = defineProps({
        image: {
            type: String,
            required: true
        },
        videoId: String,
        platform: {
            type: String,
            validator: function (value) {
                return Object.values(VideoPlatform).indexOf(value) !== -1;
            },
            required: true
        },
        size: {
            type: String,
            validator: function (value) {
                return Object.values(VideoBlockSize).indexOf(value) !== -1;
            },
            default: VideoBlockSize.large
        }
    });

    const durationFormated = computed(() => {
        let hours = Math.floor(state.duration / 3600);
        hours = hours < 10 ? '0' + hours : hours;
        const minutes = Math.floor(state.duration / 60);
        const seconds = state.duration - minutes * 60;
        return `${hours}:${minutes}:${seconds}`;
    });

    const gridClass = computed(() => {
        if (props.size === VideoBlockSize.large) {
            return 'col-12';
        } else if (props.size === VideoBlockSize.medium) {
            return 'col-12 col-md-9 offset-md-3 col-xl-6 offset-xl-3';
        }
        return 'video-block-fullbleed__video-position';
    });

    const showCustomControls = computed(() => {
        // Youtube does not support duration
        return props.platform === VideoPlatform.youtube && props.size != VideoBlockSize.fullbleed || state.duration && props.size != VideoBlockSize.fullbleed
    });

    const playVideo = () => {
        if(props.platform === VideoPlatform.vimeo) {
            player.play();
        } else {
            player.playVideo();
        }
    }

    const pauseVideo = () => {
        if(props.platform === VideoPlatform.vimeo) {
            player.pause();
        } else {
            player.pauseVideo();
        }
    }

    const handlePlayerLoaded = (p) => {
        player = p;
        setVideoDuration();
        const loopPlaylists = true;
        if(VideoBlockSize.fullbleed === props.size) {
            playVideo();
            player.setLoop(loopPlaylists);
            player.setVolume(0);
        }
    };

    const setVideoDuration = () => {
        if(props.platform === VideoPlatform.vimeo) {
            player.getDuration().then((duration) => {
                state.duration = duration;
            });
        } else {
            state.duration = player.getDuration();
        }
    };

    const handleOnPlay = () => {
        state.playing = true;
    };

    const handleOnEnded = () => {
        if(VideoBlockSize.fullbleed === props.size && VideoPlatform.youtube === props.platform) {
            playVideo();
        }
    }

    const onClick = () => {
        if( player ) {
            playVideo();
        }
    };

</script>

<script>
    export const VideoBlockSize = {
        fullbleed: 'video-block--fullbleed',
        medium: 'video-block--medium',
        large: 'video-block--large'
    };
    export const VideoPlatform = {
        youtube: 'youtube',
        vimeo: 'vimeo'
    };
</script>
